<template>
  <div id="Edit">
    <div class="leftBtn">
      <el-radio v-model="type" label="1" border>服务</el-radio>
      <el-radio v-model="type" label="2" border>机构</el-radio>
      <el-radio v-model="type" label="3" border>新闻</el-radio>
      <!-- <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
      >
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>导航一</span>
          </template>
          <el-menu-item-group>
            <template slot="title">分组一</template>
            <el-menu-item index="1-1">选项1</el-menu-item>
            <el-menu-item index="1-2">选项2</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="分组2">
            <el-menu-item index="1-3">选项3</el-menu-item>
          </el-menu-item-group>
          <el-submenu index="1-4">
            <template slot="title">选项4</template>
            <el-menu-item index="1-4-1">选项1</el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-menu-item index="2">
          <i class="el-icon-menu"></i>
          <span slot="title">导航二</span>
        </el-menu-item>
        <el-menu-item index="3" disabled>
          <i class="el-icon-document"></i>
          <span slot="title">导航三</span>
        </el-menu-item>
        <el-menu-item index="4">
          <i class="el-icon-setting"></i>
          <span slot="title">导航四</span>
        </el-menu-item>
      </el-menu> -->
    </div>
    <div>
      <ServicesEdit v-if="type == '1'"></ServicesEdit>
      <InstitutionEdit v-if="type == '2'"></InstitutionEdit>
      <Edit v-else-if="type == '3'"></Edit>
    </div>
  </div>
</template>
<script>
import Edit from "./Edit";
import ServicesEdit from "./ServicesEdit";
import InstitutionEdit from "./InstitutionEdit";
export default {
  components: {
    Edit,
    ServicesEdit,
    InstitutionEdit,
  },
  data() {
    return {
      type: "1",
    };
  },
};
</script>
<style lang="less" scoped>
#Edit {
  display: flex;
  justify-content: space-around;
  // background-color: #f0f0f0;
  background-color: #fff;

  .leftBtn {
    width: 20%;
    padding: 0 0 0 45px;
    // padding: 50px 0;
    .el-radio {
      top: 80px;
      width: 110px;
      height: 50px;
      // font-size: 23px;
      font-weight: 600;
      margin-left: 0;
      text-align: center;
      background-color: #40a0ff1f;

      /deep/.el-radio__input {
        display: none;
      }
      /deep/.el-radio__label {
        font-size: 24px;
      }

      &.is-checked {
        background-color: #40a0ff;
        color: #fff;

        /deep/.el-radio__label {
          color: #fff;
        }
      }
    }
  }
}
</style>
